import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { CssBaseline } from "@mui/material";
import { MsalProvider } from "@azure/msal-react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import App from "./App";
import "./styles.css";
import { Provider } from "react-redux";
import store from "./store";
import { AuthProvider } from "./context/AuthContext";
import ThemeProvider from "./context/ThemeContext";
import { msalInstance, msalInstanceReady } from "./msalInstance";

const renderApp = () =>
  createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
      <ThemeProvider>
        <CssBaseline />
        <Provider store={store}>
          <BrowserRouter>
            <MsalProvider instance={msalInstance}>
              <AuthProvider>
                <App />
                <ToastContainer
                  position="top-right"
                  autoClose={5000}
                  hideProgressBar={false}
                  newestOnTop={false}
                  closeOnClick
                  rtl={false}
                  pauseOnFocusLoss
                  draggable
                  pauseOnHover
                  theme="light"
                />
              </AuthProvider>
            </MsalProvider>
          </BrowserRouter>
        </Provider>
      </ThemeProvider>
    </React.StrictMode>
  );

msalInstanceReady.then(renderApp).catch((err) => {
  console.error("Failed to initialize MSAL", err);
});
